import 'element/css/tag.scss'

import Tag from 'element-ui/packages/tag'

export default Tag
